/**
 * @license BCP
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name users
 * @description
 *
 * # users
 *
 * The `users` module provides users management.
 */
angular.module("users", [])
/**
 * @ngdoc controller
 * @name loginFormCtrl
 * @requires $scope, $location, $modalInstance, b17Service, auth
 *
 * @description
 * Modal login/logout Controller with form only
 */
  .controller("loginFormCtrl", function ($scope, $location, $modalInstance, b17Service, auth) {

    $scope.location = $location.path();

    // get the token if it exists
    $scope.token = auth.getToken();
    // get the client ID
    $scope.client = auth.getClient();
    // get user data if it exists
    $scope.userInfo = auth.getUserData();
    
    if ($scope.token) { 
      auth.checkUserData().then(function(userData) {
        // get user data if it exists
        $scope.userInfo = userData;
        // get the token if it exists
        $scope.token = auth.getToken();
      });
    }
    
    $scope.close = function() {
       $modalInstance.close('Close');
    };

    $scope.authenticate = function ($username, $password) {
      $scope.inProgress = true;
      auth.loginUser($username, $password).then(function (userData) {
        $scope.inProgress = false;
        // get user data if it exists
        $scope.userInfo = auth.getUserData();
        // get the token if it exists
        $scope.token = auth.getToken();
        if (userData.error) {
          $scope.authenticationError = userData.error;
        }
      });
    };

    $scope.logout = function () {
      auth.logoutUser();
      // reset userinfo and token
      $scope.userInfo = {};
      $scope.token = "";
      $modalInstance.close('Ok');
    };
    
    $scope.reset = function() {
      $scope.client = 1;
      auth.setClient(1);
    };

    // watch $scope.client
    $scope.$watch('client', function(newValue) {
      auth.setClient(newValue);
    });

  });

})();
